import { toArray } from "./toArray.js";
export const firstOrDefault = (source, predicate) => {
    if (predicate) {
        return firstOrDefault2(source, predicate);
    }
    else {
        return firstOrDefault1(source);
    }
};
const firstOrDefault1 = async (source) => {
    const dataFunc = source.dataFunc;
    switch (dataFunc.type) {
        case 0: {
            const values = await dataFunc.generator();
            if (values.length === 0) {
                return null;
            }
            else {
                return values[0];
            }
        }
        case 1: {
            const promises = dataFunc.generator();
            if (promises.length === 0) {
                return null;
            }
            else {
                return await promises[0];
            }
        }
        case 2: {
            const promises = await dataFunc.generator();
            if (promises.length === 0) {
                return null;
            }
            else {
                return await promises[0];
            }
        }
    }
};
const firstOrDefault2 = async (source, predicate) => {
    const data = await toArray(source);
    for (const value of data) {
        if (predicate(value) === true) {
            return value;
        }
    }
    return null;
};
